// extracted by mini-css-extract-plugin
export default {"root":"style_root__XCfXd","segment":"style_segment__hoaIV","active":"style_active__oyFNm"};